// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which value/quality changes trigger a data-change notification.
 */
export enum DataChangeTrigger {
  Status = 0,
  StatusValue = 1,
  StatusValueTimestamp = 2,
}
